import React from 'react';
import {
  Col,
  Row,
  Pagination,
  PaginationItem,
  PaginationLink,
} from 'reactstrap';
import { Breadcrumbs, Collapse } from 'components';
import DefinitionList from 'components/DefinitionList';
import Button from 'components/Button';
import Tags from 'components/Tags';
import PropTypes from 'prop-types';
import './AssetDetail.scss';

const AssetDetail = props => {
  const {
    asset,
    contentTerms,
    fileInfoTerms,
    tags,
    similarAssets,
    title,
  } = props;
  return (
    <Row className="asset-detail-view" noGutters>
      <Col xs={12} md={7} lg={8} xl={9} className="asset-container">
        {asset}
      </Col>
      <Col className="asset-info">
        <div className="info-container">
          <div className="info-header info-section">
            <Breadcrumbs
              path={[{ url: '/assets/', displayName: 'All Assets' }]}
            />
            <h2>{title}</h2>
            <Row className="asset-actions">
              <Col>
                <Button color="primary" className="rounded-pill" block outline>
                  <span className="lnr lnr-download2" /> Download
                </Button>
              </Col>
              <Col>
                <Button color="primary" className="rounded-pill" block>
                  <span className="lnr lnr-checkmark-circle" /> Collect
                </Button>
              </Col>
            </Row>
          </div>
          {similarAssets && (
            <Collapse title="Similar Assets" className="minimal info-section">
              {similarAssets}
            </Collapse>
          )}
          {tags && (
            <Collapse title="Keywords" className="minimal info-section">
              <Tags tags={tags} />
            </Collapse>
          )}
          {contentTerms && (
            <Collapse title="Content" className="minimal info-section">
              <DefinitionList terms={contentTerms} />
            </Collapse>
          )}
          {fileInfoTerms && (
            <Collapse title="File Info" className="minimal info-section">
              <DefinitionList terms={fileInfoTerms} tableLayout />
            </Collapse>
          )}
        </div>
        <Pagination
          aria-label="Page navigation example"
          className="asset-detail-pagination"
        >
          <PaginationItem>
            <PaginationLink previous>
              <span className="lnr lnr-arrow-left" />
            </PaginationLink>
          </PaginationItem>
          <PaginationItem className="current-position">1 of 4</PaginationItem>
          <PaginationItem>
            <PaginationLink next>
              <span className="lnr lnr-arrow-right" />
            </PaginationLink>
          </PaginationItem>
        </Pagination>
      </Col>
    </Row>
  );
};

AssetDetail.propTypes = {
  contentTerms: PropTypes.arrayOf(PropTypes.shape({})),
  fileInfoTerms: PropTypes.arrayOf(PropTypes.shape({})),
  tags: PropTypes.arrayOf(PropTypes.string),
  similarAssets: PropTypes.node,
  asset: PropTypes.node,
  title: PropTypes.string,
};

AssetDetail.defaultProps = {
  contentTerms: [],
  fileInfoTerms: [],
  tags: [],
  similarAssets: null,
  asset: null,
  title: '',
};

export default AssetDetail;
